/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TestRouteImport } from './routes/test'
import { Route as PdftestRouteImport } from './routes/pdftest'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as DebugRouteImport } from './routes/debug'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as PublicTermsOfServiceRouteImport } from './routes/_public/terms-of-service'
import { Route as PublicSwimSignTosRouteImport } from './routes/_public/swim-sign-tos'
import { Route as PublicSellersGuideRouteImport } from './routes/_public/sellers-guide'
import { Route as PublicResetPasswordRouteImport } from './routes/_public/reset-password'
import { Route as PublicPrivacyPolicyRouteImport } from './routes/_public/privacy-policy'
import { Route as PublicAiDisclaimerRouteImport } from './routes/_public/ai-disclaimer'
import { Route as PublicAboutRouteImport } from './routes/_public/about'
import { Route as ProtectedDashboardRouteImport } from './routes/_protected/dashboard'
import { Route as PackageIdSignerIdRouteImport } from './routes/$packageId.$signerId'
import { Route as PublicPropertiesIndexRouteImport } from './routes/_public/properties/index'
import { Route as PublicBlogIndexRouteImport } from './routes/_public/blog/index'
import { Route as ProtectedDashboardIndexRouteImport } from './routes/_protected/dashboard/index'
import { Route as PublicSitemapXmlRouteImport } from './routes/_public/sitemap.xml'
import { Route as PublicPropertiesIdRouteImport } from './routes/_public/properties/$id'
import { Route as ProtectedDashboardProfileRouteImport } from './routes/_protected/dashboard/profile'
import { Route as ProtectedDashboardPaymentRouteImport } from './routes/_protected/dashboard/payment'
import { Route as ProtectedDashboardMessagesRouteImport } from './routes/_protected/dashboard/messages'
import { Route as ProtectedDashboardEditRouteImport } from './routes/_protected/dashboard/edit'
import { Route as ProtectedDashboardDocumentsRouteImport } from './routes/_protected/dashboard/documents'
import { Route as ProtectedDashboardCalendarRouteImport } from './routes/_protected/dashboard/calendar'
import { Route as PublicBlogSlugIndexRouteImport } from './routes/_public/blog/$slug/index'
import { Route as ProtectedDashboardSignaturesIndexRouteImport } from './routes/_protected/dashboard/signatures/index'
import { Route as PublicBookingsCreatePropertyIdRouteImport } from './routes/_public/bookings/create.$propertyId'
import { Route as PublicBookingsCancelBookingIdRouteImport } from './routes/_public/bookings/cancel.$bookingId'
import { Route as PublicBlogAdminNewRouteImport } from './routes/_public/blog/_admin.new'
import { Route as ProtectedDashboardSignaturesPackageIdRouteImport } from './routes/_protected/dashboard/signatures/$packageId'
import { Route as PublicBlogSlugAdminEditRouteImport } from './routes/_public/blog/$slug/_admin.edit'

const TestRoute = TestRouteImport.update({
  id: '/test',
  path: '/test',
  getParentRoute: () => rootRouteImport,
} as any)
const PdftestRoute = PdftestRouteImport.update({
  id: '/pdftest',
  path: '/pdftest',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const DebugRoute = DebugRouteImport.update({
  id: '/debug',
  path: '/debug',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicTermsOfServiceRoute = PublicTermsOfServiceRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSwimSignTosRoute = PublicSwimSignTosRouteImport.update({
  id: '/swim-sign-tos',
  path: '/swim-sign-tos',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSellersGuideRoute = PublicSellersGuideRouteImport.update({
  id: '/sellers-guide',
  path: '/sellers-guide',
  getParentRoute: () => PublicRoute,
} as any)
const PublicResetPasswordRoute = PublicResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicPrivacyPolicyRoute = PublicPrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => PublicRoute,
} as any)
const PublicAiDisclaimerRoute = PublicAiDisclaimerRouteImport.update({
  id: '/ai-disclaimer',
  path: '/ai-disclaimer',
  getParentRoute: () => PublicRoute,
} as any)
const PublicAboutRoute = PublicAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => PublicRoute,
} as any)
const ProtectedDashboardRoute = ProtectedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => ProtectedRoute,
} as any)
const PackageIdSignerIdRoute = PackageIdSignerIdRouteImport.update({
  id: '/$packageId/$signerId',
  path: '/$packageId/$signerId',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicPropertiesIndexRoute = PublicPropertiesIndexRouteImport.update({
  id: '/properties/',
  path: '/properties/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicBlogIndexRoute = PublicBlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => PublicRoute,
} as any)
const ProtectedDashboardIndexRoute = ProtectedDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedDashboardRoute,
} as any)
const PublicSitemapXmlRoute = PublicSitemapXmlRouteImport.update({
  id: '/sitemap/xml',
  path: '/sitemap/xml',
  getParentRoute: () => PublicRoute,
} as any)
const PublicPropertiesIdRoute = PublicPropertiesIdRouteImport.update({
  id: '/properties/$id',
  path: '/properties/$id',
  getParentRoute: () => PublicRoute,
} as any)
const ProtectedDashboardProfileRoute =
  ProtectedDashboardProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => ProtectedDashboardRoute,
  } as any)
const ProtectedDashboardPaymentRoute =
  ProtectedDashboardPaymentRouteImport.update({
    id: '/payment',
    path: '/payment',
    getParentRoute: () => ProtectedDashboardRoute,
  } as any)
const ProtectedDashboardMessagesRoute =
  ProtectedDashboardMessagesRouteImport.update({
    id: '/messages',
    path: '/messages',
    getParentRoute: () => ProtectedDashboardRoute,
  } as any)
const ProtectedDashboardEditRoute = ProtectedDashboardEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => ProtectedDashboardRoute,
} as any)
const ProtectedDashboardDocumentsRoute =
  ProtectedDashboardDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => ProtectedDashboardRoute,
  } as any)
const ProtectedDashboardCalendarRoute =
  ProtectedDashboardCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => ProtectedDashboardRoute,
  } as any)
const PublicBlogSlugIndexRoute = PublicBlogSlugIndexRouteImport.update({
  id: '/blog/$slug/',
  path: '/blog/$slug/',
  getParentRoute: () => PublicRoute,
} as any)
const ProtectedDashboardSignaturesIndexRoute =
  ProtectedDashboardSignaturesIndexRouteImport.update({
    id: '/signatures/',
    path: '/signatures/',
    getParentRoute: () => ProtectedDashboardRoute,
  } as any)
const PublicBookingsCreatePropertyIdRoute =
  PublicBookingsCreatePropertyIdRouteImport.update({
    id: '/bookings/create/$propertyId',
    path: '/bookings/create/$propertyId',
    getParentRoute: () => PublicRoute,
  } as any)
const PublicBookingsCancelBookingIdRoute =
  PublicBookingsCancelBookingIdRouteImport.update({
    id: '/bookings/cancel/$bookingId',
    path: '/bookings/cancel/$bookingId',
    getParentRoute: () => PublicRoute,
  } as any)
const PublicBlogAdminNewRoute = PublicBlogAdminNewRouteImport.update({
  id: '/blog/_admin/new',
  path: '/blog/new',
  getParentRoute: () => PublicRoute,
} as any)
const ProtectedDashboardSignaturesPackageIdRoute =
  ProtectedDashboardSignaturesPackageIdRouteImport.update({
    id: '/signatures/$packageId',
    path: '/signatures/$packageId',
    getParentRoute: () => ProtectedDashboardRoute,
  } as any)
const PublicBlogSlugAdminEditRoute = PublicBlogSlugAdminEditRouteImport.update({
  id: '/blog/$slug/_admin/edit',
  path: '/blog/$slug/edit',
  getParentRoute: () => PublicRoute,
} as any)

export interface FileRoutesByFullPath {
  '/debug': typeof DebugRoute
  '/logout': typeof LogoutRoute
  '/pdftest': typeof PdftestRoute
  '/test': typeof TestRoute
  '/$packageId/$signerId': typeof PackageIdSignerIdRoute
  '/dashboard': typeof ProtectedDashboardRouteWithChildren
  '/about': typeof PublicAboutRoute
  '/ai-disclaimer': typeof PublicAiDisclaimerRoute
  '/privacy-policy': typeof PublicPrivacyPolicyRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/sellers-guide': typeof PublicSellersGuideRoute
  '/swim-sign-tos': typeof PublicSwimSignTosRoute
  '/terms-of-service': typeof PublicTermsOfServiceRoute
  '/': typeof PublicIndexRoute
  '/dashboard/calendar': typeof ProtectedDashboardCalendarRoute
  '/dashboard/documents': typeof ProtectedDashboardDocumentsRoute
  '/dashboard/edit': typeof ProtectedDashboardEditRoute
  '/dashboard/messages': typeof ProtectedDashboardMessagesRoute
  '/dashboard/payment': typeof ProtectedDashboardPaymentRoute
  '/dashboard/profile': typeof ProtectedDashboardProfileRoute
  '/properties/$id': typeof PublicPropertiesIdRoute
  '/sitemap/xml': typeof PublicSitemapXmlRoute
  '/dashboard/': typeof ProtectedDashboardIndexRoute
  '/blog': typeof PublicBlogIndexRoute
  '/properties': typeof PublicPropertiesIndexRoute
  '/dashboard/signatures/$packageId': typeof ProtectedDashboardSignaturesPackageIdRoute
  '/blog/new': typeof PublicBlogAdminNewRoute
  '/bookings/cancel/$bookingId': typeof PublicBookingsCancelBookingIdRoute
  '/bookings/create/$propertyId': typeof PublicBookingsCreatePropertyIdRoute
  '/dashboard/signatures': typeof ProtectedDashboardSignaturesIndexRoute
  '/blog/$slug': typeof PublicBlogSlugIndexRoute
  '/blog/$slug/edit': typeof PublicBlogSlugAdminEditRoute
}
export interface FileRoutesByTo {
  '/debug': typeof DebugRoute
  '/logout': typeof LogoutRoute
  '/pdftest': typeof PdftestRoute
  '/test': typeof TestRoute
  '/$packageId/$signerId': typeof PackageIdSignerIdRoute
  '/about': typeof PublicAboutRoute
  '/ai-disclaimer': typeof PublicAiDisclaimerRoute
  '/privacy-policy': typeof PublicPrivacyPolicyRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/sellers-guide': typeof PublicSellersGuideRoute
  '/swim-sign-tos': typeof PublicSwimSignTosRoute
  '/terms-of-service': typeof PublicTermsOfServiceRoute
  '/': typeof PublicIndexRoute
  '/dashboard/calendar': typeof ProtectedDashboardCalendarRoute
  '/dashboard/documents': typeof ProtectedDashboardDocumentsRoute
  '/dashboard/edit': typeof ProtectedDashboardEditRoute
  '/dashboard/messages': typeof ProtectedDashboardMessagesRoute
  '/dashboard/payment': typeof ProtectedDashboardPaymentRoute
  '/dashboard/profile': typeof ProtectedDashboardProfileRoute
  '/properties/$id': typeof PublicPropertiesIdRoute
  '/sitemap/xml': typeof PublicSitemapXmlRoute
  '/dashboard': typeof ProtectedDashboardIndexRoute
  '/blog': typeof PublicBlogIndexRoute
  '/properties': typeof PublicPropertiesIndexRoute
  '/dashboard/signatures/$packageId': typeof ProtectedDashboardSignaturesPackageIdRoute
  '/blog/new': typeof PublicBlogAdminNewRoute
  '/bookings/cancel/$bookingId': typeof PublicBookingsCancelBookingIdRoute
  '/bookings/create/$propertyId': typeof PublicBookingsCreatePropertyIdRoute
  '/dashboard/signatures': typeof ProtectedDashboardSignaturesIndexRoute
  '/blog/$slug': typeof PublicBlogSlugIndexRoute
  '/blog/$slug/edit': typeof PublicBlogSlugAdminEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_protected': typeof ProtectedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/debug': typeof DebugRoute
  '/logout': typeof LogoutRoute
  '/pdftest': typeof PdftestRoute
  '/test': typeof TestRoute
  '/$packageId/$signerId': typeof PackageIdSignerIdRoute
  '/_protected/dashboard': typeof ProtectedDashboardRouteWithChildren
  '/_public/about': typeof PublicAboutRoute
  '/_public/ai-disclaimer': typeof PublicAiDisclaimerRoute
  '/_public/privacy-policy': typeof PublicPrivacyPolicyRoute
  '/_public/reset-password': typeof PublicResetPasswordRoute
  '/_public/sellers-guide': typeof PublicSellersGuideRoute
  '/_public/swim-sign-tos': typeof PublicSwimSignTosRoute
  '/_public/terms-of-service': typeof PublicTermsOfServiceRoute
  '/_public/': typeof PublicIndexRoute
  '/_protected/dashboard/calendar': typeof ProtectedDashboardCalendarRoute
  '/_protected/dashboard/documents': typeof ProtectedDashboardDocumentsRoute
  '/_protected/dashboard/edit': typeof ProtectedDashboardEditRoute
  '/_protected/dashboard/messages': typeof ProtectedDashboardMessagesRoute
  '/_protected/dashboard/payment': typeof ProtectedDashboardPaymentRoute
  '/_protected/dashboard/profile': typeof ProtectedDashboardProfileRoute
  '/_public/properties/$id': typeof PublicPropertiesIdRoute
  '/_public/sitemap/xml': typeof PublicSitemapXmlRoute
  '/_protected/dashboard/': typeof ProtectedDashboardIndexRoute
  '/_public/blog/': typeof PublicBlogIndexRoute
  '/_public/properties/': typeof PublicPropertiesIndexRoute
  '/_protected/dashboard/signatures/$packageId': typeof ProtectedDashboardSignaturesPackageIdRoute
  '/_public/blog/_admin/new': typeof PublicBlogAdminNewRoute
  '/_public/bookings/cancel/$bookingId': typeof PublicBookingsCancelBookingIdRoute
  '/_public/bookings/create/$propertyId': typeof PublicBookingsCreatePropertyIdRoute
  '/_protected/dashboard/signatures/': typeof ProtectedDashboardSignaturesIndexRoute
  '/_public/blog/$slug/': typeof PublicBlogSlugIndexRoute
  '/_public/blog/$slug/_admin/edit': typeof PublicBlogSlugAdminEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/debug'
    | '/logout'
    | '/pdftest'
    | '/test'
    | '/$packageId/$signerId'
    | '/dashboard'
    | '/about'
    | '/ai-disclaimer'
    | '/privacy-policy'
    | '/reset-password'
    | '/sellers-guide'
    | '/swim-sign-tos'
    | '/terms-of-service'
    | '/'
    | '/dashboard/calendar'
    | '/dashboard/documents'
    | '/dashboard/edit'
    | '/dashboard/messages'
    | '/dashboard/payment'
    | '/dashboard/profile'
    | '/properties/$id'
    | '/sitemap/xml'
    | '/dashboard/'
    | '/blog'
    | '/properties'
    | '/dashboard/signatures/$packageId'
    | '/blog/new'
    | '/bookings/cancel/$bookingId'
    | '/bookings/create/$propertyId'
    | '/dashboard/signatures'
    | '/blog/$slug'
    | '/blog/$slug/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/debug'
    | '/logout'
    | '/pdftest'
    | '/test'
    | '/$packageId/$signerId'
    | '/about'
    | '/ai-disclaimer'
    | '/privacy-policy'
    | '/reset-password'
    | '/sellers-guide'
    | '/swim-sign-tos'
    | '/terms-of-service'
    | '/'
    | '/dashboard/calendar'
    | '/dashboard/documents'
    | '/dashboard/edit'
    | '/dashboard/messages'
    | '/dashboard/payment'
    | '/dashboard/profile'
    | '/properties/$id'
    | '/sitemap/xml'
    | '/dashboard'
    | '/blog'
    | '/properties'
    | '/dashboard/signatures/$packageId'
    | '/blog/new'
    | '/bookings/cancel/$bookingId'
    | '/bookings/create/$propertyId'
    | '/dashboard/signatures'
    | '/blog/$slug'
    | '/blog/$slug/edit'
  id:
    | '__root__'
    | '/_protected'
    | '/_public'
    | '/debug'
    | '/logout'
    | '/pdftest'
    | '/test'
    | '/$packageId/$signerId'
    | '/_protected/dashboard'
    | '/_public/about'
    | '/_public/ai-disclaimer'
    | '/_public/privacy-policy'
    | '/_public/reset-password'
    | '/_public/sellers-guide'
    | '/_public/swim-sign-tos'
    | '/_public/terms-of-service'
    | '/_public/'
    | '/_protected/dashboard/calendar'
    | '/_protected/dashboard/documents'
    | '/_protected/dashboard/edit'
    | '/_protected/dashboard/messages'
    | '/_protected/dashboard/payment'
    | '/_protected/dashboard/profile'
    | '/_public/properties/$id'
    | '/_public/sitemap/xml'
    | '/_protected/dashboard/'
    | '/_public/blog/'
    | '/_public/properties/'
    | '/_protected/dashboard/signatures/$packageId'
    | '/_public/blog/_admin/new'
    | '/_public/bookings/cancel/$bookingId'
    | '/_public/bookings/create/$propertyId'
    | '/_protected/dashboard/signatures/'
    | '/_public/blog/$slug/'
    | '/_public/blog/$slug/_admin/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ProtectedRoute: typeof ProtectedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  DebugRoute: typeof DebugRoute
  LogoutRoute: typeof LogoutRoute
  PdftestRoute: typeof PdftestRoute
  TestRoute: typeof TestRoute
  PackageIdSignerIdRoute: typeof PackageIdSignerIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/test': {
      id: '/test'
      path: '/test'
      fullPath: '/test'
      preLoaderRoute: typeof TestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pdftest': {
      id: '/pdftest'
      path: '/pdftest'
      fullPath: '/pdftest'
      preLoaderRoute: typeof PdftestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/debug': {
      id: '/debug'
      path: '/debug'
      fullPath: '/debug'
      preLoaderRoute: typeof DebugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/terms-of-service': {
      id: '/_public/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof PublicTermsOfServiceRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/swim-sign-tos': {
      id: '/_public/swim-sign-tos'
      path: '/swim-sign-tos'
      fullPath: '/swim-sign-tos'
      preLoaderRoute: typeof PublicSwimSignTosRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sellers-guide': {
      id: '/_public/sellers-guide'
      path: '/sellers-guide'
      fullPath: '/sellers-guide'
      preLoaderRoute: typeof PublicSellersGuideRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/reset-password': {
      id: '/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof PublicResetPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/privacy-policy': {
      id: '/_public/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PublicPrivacyPolicyRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/ai-disclaimer': {
      id: '/_public/ai-disclaimer'
      path: '/ai-disclaimer'
      fullPath: '/ai-disclaimer'
      preLoaderRoute: typeof PublicAiDisclaimerRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/about': {
      id: '/_public/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof PublicAboutRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_protected/dashboard': {
      id: '/_protected/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof ProtectedDashboardRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/$packageId/$signerId': {
      id: '/$packageId/$signerId'
      path: '/$packageId/$signerId'
      fullPath: '/$packageId/$signerId'
      preLoaderRoute: typeof PackageIdSignerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/properties/': {
      id: '/_public/properties/'
      path: '/properties'
      fullPath: '/properties'
      preLoaderRoute: typeof PublicPropertiesIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/blog/': {
      id: '/_public/blog/'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof PublicBlogIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_protected/dashboard/': {
      id: '/_protected/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof ProtectedDashboardIndexRouteImport
      parentRoute: typeof ProtectedDashboardRoute
    }
    '/_public/sitemap/xml': {
      id: '/_public/sitemap/xml'
      path: '/sitemap/xml'
      fullPath: '/sitemap/xml'
      preLoaderRoute: typeof PublicSitemapXmlRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/properties/$id': {
      id: '/_public/properties/$id'
      path: '/properties/$id'
      fullPath: '/properties/$id'
      preLoaderRoute: typeof PublicPropertiesIdRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_protected/dashboard/profile': {
      id: '/_protected/dashboard/profile'
      path: '/profile'
      fullPath: '/dashboard/profile'
      preLoaderRoute: typeof ProtectedDashboardProfileRouteImport
      parentRoute: typeof ProtectedDashboardRoute
    }
    '/_protected/dashboard/payment': {
      id: '/_protected/dashboard/payment'
      path: '/payment'
      fullPath: '/dashboard/payment'
      preLoaderRoute: typeof ProtectedDashboardPaymentRouteImport
      parentRoute: typeof ProtectedDashboardRoute
    }
    '/_protected/dashboard/messages': {
      id: '/_protected/dashboard/messages'
      path: '/messages'
      fullPath: '/dashboard/messages'
      preLoaderRoute: typeof ProtectedDashboardMessagesRouteImport
      parentRoute: typeof ProtectedDashboardRoute
    }
    '/_protected/dashboard/edit': {
      id: '/_protected/dashboard/edit'
      path: '/edit'
      fullPath: '/dashboard/edit'
      preLoaderRoute: typeof ProtectedDashboardEditRouteImport
      parentRoute: typeof ProtectedDashboardRoute
    }
    '/_protected/dashboard/documents': {
      id: '/_protected/dashboard/documents'
      path: '/documents'
      fullPath: '/dashboard/documents'
      preLoaderRoute: typeof ProtectedDashboardDocumentsRouteImport
      parentRoute: typeof ProtectedDashboardRoute
    }
    '/_protected/dashboard/calendar': {
      id: '/_protected/dashboard/calendar'
      path: '/calendar'
      fullPath: '/dashboard/calendar'
      preLoaderRoute: typeof ProtectedDashboardCalendarRouteImport
      parentRoute: typeof ProtectedDashboardRoute
    }
    '/_public/blog/$slug/': {
      id: '/_public/blog/$slug/'
      path: '/blog/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof PublicBlogSlugIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_protected/dashboard/signatures/': {
      id: '/_protected/dashboard/signatures/'
      path: '/signatures'
      fullPath: '/dashboard/signatures'
      preLoaderRoute: typeof ProtectedDashboardSignaturesIndexRouteImport
      parentRoute: typeof ProtectedDashboardRoute
    }
    '/_public/bookings/create/$propertyId': {
      id: '/_public/bookings/create/$propertyId'
      path: '/bookings/create/$propertyId'
      fullPath: '/bookings/create/$propertyId'
      preLoaderRoute: typeof PublicBookingsCreatePropertyIdRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/bookings/cancel/$bookingId': {
      id: '/_public/bookings/cancel/$bookingId'
      path: '/bookings/cancel/$bookingId'
      fullPath: '/bookings/cancel/$bookingId'
      preLoaderRoute: typeof PublicBookingsCancelBookingIdRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/blog/_admin/new': {
      id: '/_public/blog/_admin/new'
      path: '/blog/new'
      fullPath: '/blog/new'
      preLoaderRoute: typeof PublicBlogAdminNewRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_protected/dashboard/signatures/$packageId': {
      id: '/_protected/dashboard/signatures/$packageId'
      path: '/signatures/$packageId'
      fullPath: '/dashboard/signatures/$packageId'
      preLoaderRoute: typeof ProtectedDashboardSignaturesPackageIdRouteImport
      parentRoute: typeof ProtectedDashboardRoute
    }
    '/_public/blog/$slug/_admin/edit': {
      id: '/_public/blog/$slug/_admin/edit'
      path: '/blog/$slug/edit'
      fullPath: '/blog/$slug/edit'
      preLoaderRoute: typeof PublicBlogSlugAdminEditRouteImport
      parentRoute: typeof PublicRoute
    }
  }
}

interface ProtectedDashboardRouteChildren {
  ProtectedDashboardCalendarRoute: typeof ProtectedDashboardCalendarRoute
  ProtectedDashboardDocumentsRoute: typeof ProtectedDashboardDocumentsRoute
  ProtectedDashboardEditRoute: typeof ProtectedDashboardEditRoute
  ProtectedDashboardMessagesRoute: typeof ProtectedDashboardMessagesRoute
  ProtectedDashboardPaymentRoute: typeof ProtectedDashboardPaymentRoute
  ProtectedDashboardProfileRoute: typeof ProtectedDashboardProfileRoute
  ProtectedDashboardIndexRoute: typeof ProtectedDashboardIndexRoute
  ProtectedDashboardSignaturesPackageIdRoute: typeof ProtectedDashboardSignaturesPackageIdRoute
  ProtectedDashboardSignaturesIndexRoute: typeof ProtectedDashboardSignaturesIndexRoute
}

const ProtectedDashboardRouteChildren: ProtectedDashboardRouteChildren = {
  ProtectedDashboardCalendarRoute: ProtectedDashboardCalendarRoute,
  ProtectedDashboardDocumentsRoute: ProtectedDashboardDocumentsRoute,
  ProtectedDashboardEditRoute: ProtectedDashboardEditRoute,
  ProtectedDashboardMessagesRoute: ProtectedDashboardMessagesRoute,
  ProtectedDashboardPaymentRoute: ProtectedDashboardPaymentRoute,
  ProtectedDashboardProfileRoute: ProtectedDashboardProfileRoute,
  ProtectedDashboardIndexRoute: ProtectedDashboardIndexRoute,
  ProtectedDashboardSignaturesPackageIdRoute:
    ProtectedDashboardSignaturesPackageIdRoute,
  ProtectedDashboardSignaturesIndexRoute:
    ProtectedDashboardSignaturesIndexRoute,
}

const ProtectedDashboardRouteWithChildren =
  ProtectedDashboardRoute._addFileChildren(ProtectedDashboardRouteChildren)

interface ProtectedRouteChildren {
  ProtectedDashboardRoute: typeof ProtectedDashboardRouteWithChildren
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedDashboardRoute: ProtectedDashboardRouteWithChildren,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

interface PublicRouteChildren {
  PublicAboutRoute: typeof PublicAboutRoute
  PublicAiDisclaimerRoute: typeof PublicAiDisclaimerRoute
  PublicPrivacyPolicyRoute: typeof PublicPrivacyPolicyRoute
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute
  PublicSellersGuideRoute: typeof PublicSellersGuideRoute
  PublicSwimSignTosRoute: typeof PublicSwimSignTosRoute
  PublicTermsOfServiceRoute: typeof PublicTermsOfServiceRoute
  PublicIndexRoute: typeof PublicIndexRoute
  PublicPropertiesIdRoute: typeof PublicPropertiesIdRoute
  PublicSitemapXmlRoute: typeof PublicSitemapXmlRoute
  PublicBlogIndexRoute: typeof PublicBlogIndexRoute
  PublicPropertiesIndexRoute: typeof PublicPropertiesIndexRoute
  PublicBlogAdminNewRoute: typeof PublicBlogAdminNewRoute
  PublicBookingsCancelBookingIdRoute: typeof PublicBookingsCancelBookingIdRoute
  PublicBookingsCreatePropertyIdRoute: typeof PublicBookingsCreatePropertyIdRoute
  PublicBlogSlugIndexRoute: typeof PublicBlogSlugIndexRoute
  PublicBlogSlugAdminEditRoute: typeof PublicBlogSlugAdminEditRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicAboutRoute: PublicAboutRoute,
  PublicAiDisclaimerRoute: PublicAiDisclaimerRoute,
  PublicPrivacyPolicyRoute: PublicPrivacyPolicyRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
  PublicSellersGuideRoute: PublicSellersGuideRoute,
  PublicSwimSignTosRoute: PublicSwimSignTosRoute,
  PublicTermsOfServiceRoute: PublicTermsOfServiceRoute,
  PublicIndexRoute: PublicIndexRoute,
  PublicPropertiesIdRoute: PublicPropertiesIdRoute,
  PublicSitemapXmlRoute: PublicSitemapXmlRoute,
  PublicBlogIndexRoute: PublicBlogIndexRoute,
  PublicPropertiesIndexRoute: PublicPropertiesIndexRoute,
  PublicBlogAdminNewRoute: PublicBlogAdminNewRoute,
  PublicBookingsCancelBookingIdRoute: PublicBookingsCancelBookingIdRoute,
  PublicBookingsCreatePropertyIdRoute: PublicBookingsCreatePropertyIdRoute,
  PublicBlogSlugIndexRoute: PublicBlogSlugIndexRoute,
  PublicBlogSlugAdminEditRoute: PublicBlogSlugAdminEditRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  ProtectedRoute: ProtectedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  DebugRoute: DebugRoute,
  LogoutRoute: LogoutRoute,
  PdftestRoute: PdftestRoute,
  TestRoute: TestRoute,
  PackageIdSignerIdRoute: PackageIdSignerIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
